import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { Newsfeed, RequestUser } from "../../models/models";
import { RefdataProvider } from '../../providers/refdata/refdata'

@Injectable({
    providedIn: 'root'
})
export class NewsfeedServiceProvider {

  private baseUrl = '';
  private headers = new HttpHeaders({ "x-api-key": "Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx", "Content-Type": "application/json" });
  bhutil: any;

  constructor(public http: HttpClient, private refdata: RefdataProvider) { 
    this.baseUrl = this.refdata.getEnvVar('apiBaseUrl');
  }

    // Helper to configure POST body options using modern HttpClient structure
  private getOptions() {
      return { headers: this.headers };
  }

  getNewsFeed(user: RequestUser): Observable<Newsfeed[]> {

    const options = {
        ...this.getOptions(),
        observe: 'response' as const, // Use 'as const' for strict typing
        responseType: 'json' as const
    };
    let endpoint = "/newsfeed";
    const postUrl: string = this.baseUrl + endpoint

    return this.http.post<Newsfeed[]>(
                postUrl, 
                user, 
                { 
                    headers: this.headers,
                    // HttpClient automatically parses JSON response by default, 
                    // so we don't need responseType: 'json' unless overriding defaults.
                }
            )
            .pipe(
                // 2. Handle timeout using RxJS operator (replaces .timeout(30000))
                // If the request takes longer than 30 seconds (30000 ms), it throws a timeout error.
                timeout(30000), 

                // 3. Map the successful response (Response body is already parsed as Newsfeed[])
                map((newsFeedData: Newsfeed[]) => {
                    // If the server returns an array directly, this is all you need.
                    return newsFeedData; 
                }),

                // 4. Catch and translate errors (replaces .catch())
                catchError((error: any) => {
                    // If the error contains a structure we can parse (e.g., previous server error response)
                    if (error && error.error && typeof error.error === 'object' && error.error.message) {
                        // Return an observable that throws the specific error message
                        return throwError(() => new Error(`Server error: ${error.error.message}`));
                    } 
                    
                    // If it's a network error or timeout, throw a generic error
                    return throwError(() => new Error("Server error: Could not retrieve news feed."));
                })
            );
        }
}
